import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

export const PriceBreakdownDayRate = ({ discount, currency }) => {
  return (
    <div
      className='flex space-between'
      data-testing-id='price-breakdown-day-rate'
    >
      <span
        className='summary-item-text'
        data-testing-id='price-breakdown-day-rate-label'
      >
        <FormattedMessage
          id='inbox.create_calculator.day_rate_discount'
          defaultMessage='8+ hour discount ({percent})'
          values={{
            percent: (
              <FormattedNumber style='percent' value={discount.value / 100} />
            )
          }}
        />
      </span>
      <span
        className='text-green'
        data-testing-id='price-breakdown-day-rate-amount'
      >
        <FormattedNumber
          value={-discount.discount_amount}
          currency={currency}
          style='currency'
        />
      </span>
    </div>
  );
};

PriceBreakdownDayRate.propTypes = {
  discount: PropTypes.object.isRequired,
  currency: PropTypes.string.isRequired
};
